import axios from 'axios';
import { getAccountInfo } from './auth';
import { generateDeviceInfo } from '../../utils';
import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import { SMARTFREN_CG_URL } from '../../config/URL';
import { configKeys, remoteConfig } from '../../service/firebase';

const BASE_CONFIG_URL = remoteConfig
  .getValue(configKeys.userApiBaseUrl)
  .asString();

const SMARTFREN_BE_URL = `${BASE_URL}/user/v1.0/smartfren/msisdn?MSISDN=770847222934&productId=GENFLREGGF&opcoId=1001&transId=`;

export const setFirstloadFlag = () => () => {
  localStorage.setItem('GFFirstLoad', 'true');
};

export const deleteFirstloadFlag = () => () => {
  localStorage.removeItem('GFFirstLoad');
};

export const getCGSmartfrenURL = (transID) => () => {
  return `${SMARTFREN_CG_URL}/SingleSiteHE/getHE?CpId=PTFESTIVACL&productID=GENFLREGGF&CpId=PTFESTIVACL&CpPwd=PTFESTIVACL123&CpName=PTFESTIVACL&pName=GENFLREGGF&transID=${transID}&opcoId=1001`;
};

export const postSFTransID = (transID) => async (dispatch, getState) => {
  try {
    const res = await axios.post(
      `${BASE_CONFIG_URL}/user/v1.0/sessions/smartfren`,
      {
        transId: transID,
        device: generateDeviceInfo(),
      },
      {
        headers: {
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );

    dispatch({
      type: 'LOGIN_SUCCESS',
      data: res.data.data,
    });
    dispatch(getAccountInfo());
  } catch (err) {
    throw err;
  }
};

export const callSmartfrenAPI = (transID) => async (duspatch, getState) => {
  try {
    const res = await axios.get(
      `${BASE_CONFIG_URL}/user/v1.0/smartfren/transid?transID=${transID}`,
      {
        headers: {
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );
    console.log(res.data);
  } catch (err) {
    console.log(err);
  }
};

export const storeTransID = (transID) => async (dispatch, getState) => {
  try {
    const url = SMARTFREN_BE_URL + transID;
    await axios.get(url);
  } catch (err) {
    throw err;
  }
};
